import { openDB } from "idb";
import { isSafari } from "react-device-detect";
import { workContentService } from "./WorkContentService";

/**
 * オフラインサービスクラス
 */
class OfflineService {
  /**
   * データベースに接続し、オブジェクトストアを指定する
   * @memberof OfflineService
   */
  async openDB() {
    try {
      return await openDB("kobayashi_moc", 4, {
        upgrade(db) {
          db.createObjectStore("workContents", {
            keyPath: "id",
            autoIncrement: true,
          });
        },
      });
    } catch (error) {
      console.error(error);
    }
  }
  /**
   * データを登録する（Safari でのみ実行）
   * @param {object} data 作業データ
   * @memberof OfflineService
   */
  async create(data) {
    try {
      if (isSafari) {
        const db = await this.openDB();
        await db.add("workContents", data);
        return {
          data: { success: true, message: "データを IndexedDB に追加しました" },
        };
      }
    } catch (error) {
      console.error(error);
      return {
        data: { success: false, message: "データの追加に失敗しました" },
      };
    }
  }
  /**
   * データを削除する（Safari でのみ実行）
   * @param {number} workId 作業ID
   * @memberof OfflineService
   */
  async delete(workId) {
    try {
      if (isSafari) {
        const db = await this.openDB();
        await db.delete("workContents", workId);
        return {
          data: { success: true, message: "IndexedDB のデータを削除しました" },
        };
      }
    } catch (error) {
      console.error(error);
      return {
        data: { success: false, message: "データの削除に失敗しました" },
      };
    }
  }
  /**
   * 未送信データを取得・再送する（Safari でのみ実行）
   * @memberof OfflineService
   */
  async syncDatas() {
    try {
      if (isSafari) {
        const db = await this.openDB();
        const tx = db.transaction(["workContents"], "readonly");
        const store = tx.objectStore("workContents");
        const localDatas = await store.getAll();
        if (localDatas.length > 0) {
          localDatas.forEach(async (params) => {
            // データを登録する
            const result = (await workContentService.createDirect(params)).data;
            if (result.success) {
              // 登録に成功したら IndexedDB からデータを削除する
              await this.delete(params.id);
            }
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  /**
   * 未送信データの件数を取得する（Safari でのみ実行）
   * @memberof OfflineService
   */
  async count() {
    try {
      if (isSafari) {
        const db = await this.openDB();
        const tx = db.transaction(["workContents"], "readonly");
        const store = tx.objectStore("workContents");
        const result = await store.getAll();
        return result.length;
      }
      return 0;
    } catch (error) {
      console.error(error);
      return 0;
    }
  }
}
export const offlineService = new OfflineService();
